import I18n from 'I18n';
import { FilterIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { useCallback } from 'react';
import { EVENTS } from 'reporting-enablement/lib/events';
import { ADD_ONS } from '../constants/ReportCardOptions';
import { getValidatedPrimaryTracker } from '../utils/tracking';
import useCloneTracker from 'reporting-enablement/hooks/useCloneTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReportActionViewReport({
  setIsReportViewerIsOpen,
  onClickViewSRVAction
}) {
  const primaryTracker = getValidatedPrimaryTracker();
  const usageTracker = useCloneTracker(primaryTracker);
  const onClickViewReport = useCallback(() => {
    if (onClickViewSRVAction) {
      onClickViewSRVAction();
    } else {
      setIsReportViewerIsOpen(true);
    }
    usageTracker.track(EVENTS.reportCardV2Interaction, {
      action: ADD_ONS.VIEW_SRV
    });
  }, [onClickViewSRVAction, setIsReportViewerIsOpen, usageTracker]);
  return /*#__PURE__*/_jsx(IconButton, {
    "data-test-id": "report-action-view-report",
    "aria-label": I18n.text('reporting-enablement.reportCardV2.reportActions.viewReport'),
    use: "link",
    onClick: onClickViewReport,
    padding: "0",
    size: "md",
    children: /*#__PURE__*/_jsx(FilterIcon, {})
  });
}